import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Pager } from '@app/interface/myim.interface';

const ACTIVE_PAGE_LENGTH = 4;

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnChanges {

  @Output() changePage = new EventEmitter<any>(true);
  @Input() initialPage = 1;
  @Input() pageSize = 10;
  @Input() maxPages = 10;
  @Input() totalRecordCount: number;
  @Input() showArrow: boolean = false;

  public activePages: any[] = [];
  public activePageLength = ACTIVE_PAGE_LENGTH;
  public endPageMultiple = 10;
  public pager: any = {};

  ngOnChanges(changes: SimpleChanges) {
    if (changes.pageSize && changes.pageSize.currentValue != changes.pageSize.previousValue && changes.pageSize.previousValue) {
      this.setPage(this.initialPage);
    }
    if (this.totalRecordCount && changes.totalRecordCount) {
      this.setPage(this.initialPage);
    }
    if (this.totalRecordCount >= 10) {
      this.activePages = this.getActive(this.pager.currentPage);
    }
  }

  setPage(page: number, toHighlight = false) {
    // get new pager object for specified page
    this.pager = this.paginate(this.totalRecordCount, page, this.pageSize, this.maxPages);
    if (this.totalRecordCount >= 10) {
      this.activePages = this.getActive(this.pager.currentPage);
    }
    // get new page of items
    if (this.pager && !toHighlight) {
      // call change page function in parent component
      this.changePage.emit(this.pager);
    }
  }

  prevBlock(activePages: any[]) {
    let newPage = activePages[0] - 1;
    this.setPage(newPage);
  }

  nextBlock(activePages: any[]) {
    let newPage = activePages[ACTIVE_PAGE_LENGTH - 1] + 1;
    this.setPage(newPage);
  }

  paginate(totalItems: number, currentPage: number = 1, pageSize: number = 10, maxPages: number = 10) {
    // calculate total pages
    const totalPages = Math.ceil(totalItems / pageSize);

    // ensure current page isn't out of range
    if (currentPage < 1) {
      currentPage = 1;
    } else if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    let startPage: number;
    let endPage: number;
    if (totalPages <= maxPages) {
      // total pages less than max so show all pages
      startPage = 1;
      endPage = totalPages;
    } else {
      // total pages more than max so calculate start and end pages
      const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
      const maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
      if (currentPage <= maxPagesBeforeCurrentPage) {
        // current page near the start
        startPage = 1;
        endPage = maxPages;
      } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
        // current page near the end
        startPage = totalPages - maxPages + 1;
        endPage = totalPages;
      } else {
        // current page somewhere in the middle
        startPage = currentPage - maxPagesBeforeCurrentPage;
        endPage = currentPage + maxPagesAfterCurrentPage;
      }
    }

    // create an array of pages to ng-repeat in the pager control
    const pages = Array.from(Array(endPage + 1 - startPage).keys()).map((i) => startPage + i);

    // return object with all pager properties required by the view
    currentPage = currentPage == 0 ? 1 : currentPage
    const pager: Pager = { currentPage, totalPages, pages };

    return pager;
  }

  private getActive(currentPage: number): any[] {
    let start = 0;
    let arr = Array.from(Array(ACTIVE_PAGE_LENGTH + 1).keys()).splice(0, ACTIVE_PAGE_LENGTH);
    start = (currentPage % ACTIVE_PAGE_LENGTH) == 0 ? currentPage - (ACTIVE_PAGE_LENGTH - 1) : currentPage - ((currentPage % ACTIVE_PAGE_LENGTH) - 1);
    let res = [];
    res = arr.map(val => {
      if (start + val <= this.pager.totalPages)
        return start + val
    });
    res = res.filter(element => { return element != undefined; });
    return res;
  }

  public getStartPage(n) {
    let x = n / this.endPageMultiple;
    if (x.toString().indexOf('.') > -1) {
      return (Math.floor(n / this.endPageMultiple) * this.endPageMultiple) == 0 ? 1 : (Math.floor(n / this.endPageMultiple) * this.endPageMultiple);
    }
    else {
      return (x * this.endPageMultiple) - this.endPageMultiple;
    }
  }

  public setStartPage(n) {
    this.setPage(this.getStartPage(n));
  }

  public getEndPage(n, totalpages) {
    let res: any;
    let x = n / this.endPageMultiple;
    if (x.toString().indexOf('.') > -1) {
      res = Math.ceil(n / this.endPageMultiple) * this.endPageMultiple;
    }
    else {
      res = (x * this.endPageMultiple) + this.endPageMultiple;
    }
    return res >= totalpages ? totalpages : res;
  }

  public setEndPage(n, totalpages) {
    this.setPage(this.getEndPage(n, totalpages));
  }

}
